import { QueryClient, QueryClientProvider } from 'react-query'
import { Routes } from './components/Routes/Routes';
import { AuthProvider } from './contexts/AuthContext';
import { A2HSProvider } from './contexts/A2HSContext';

const theme = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // columns
    gutterWidth: 1, // rem
    outerMargin: 2, // rem
    mediaQuery: 'only screen',
    container: {
      sm: 46, // rem
      md: 61, // rem
      lg: 76  // rem
    },
    breakpoints: {
      xs: 0,  // em
      sm: 48, // em
      md: 64, // em
      lg: 75  // em
    }
  }
}

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <A2HSProvider>
          <Routes />
        </A2HSProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
